import { type FC, type SVGProps } from 'react';

import {
  AmericanFootball,
  Baseball,
  Basketball,
  Boxing,
  HorseRacing,
  IceHockey,
  Soccer,
  Star,
} from './assets/sport-icons';

type SportIconComponent = FC<SVGProps<SVGSVGElement>>;

// Canonical Oddschecker categoryGroupId -> sport icon, confirmed against the live
// category-group list. Greyhounds (5) and any other unmapped sport fall back to Star.
const SPORT_ICON_BY_CATEGORY_GROUP_ID = new Map<number, SportIconComponent>([
  [2, Soccer], // Football (soccer)
  [3, HorseRacing], // Horse Racing
  [10, Boxing], // Boxing
  [18, AmericanFootball], // American Football
  [45, IceHockey], // Ice Hockey
  [46, Baseball], // Baseball
  [47, Basketball], // Basketball
]);

export const getSportIcon = (categoryGroupId: number): SportIconComponent =>
  SPORT_ICON_BY_CATEGORY_GROUP_ID.get(categoryGroupId) ?? Star;
